import { jsx as ___EmotionJSX } from "@emotion/core";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. */
import * as React from 'react';
var SvgAlertWarning = React.forwardRef(function (props, svgRef) {
  return ___EmotionJSX("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), ___EmotionJSX("path", {
    fill: "currentColor",
    d: "M0 16C0 7.164 7.164 0 16 0c8.837 0 16 7.164 16 16s-7.163 16-16 16C7.164 32 0 24.836 0 16zm16 12c6.627 0 12-5.373 12-12S22.627 4 16 4 4 9.373 4 16s5.373 12 12 12zM14.09 8.084c.06-.055.167-.084.323-.084h3.174c.155 0 .261.029.323.084.059.057.09.157.09.302l-.337 9.226c0 .146-.029.246-.09.302-.059.055-.167.084-.323.084h-2.503c-.154 0-.262-.029-.322-.084-.06-.056-.09-.157-.09-.302L14 8.386c0-.146.029-.245.09-.302zm3.82 15.819c-.061.066-.168.097-.323.097h-3.174c-.155 0-.262-.031-.323-.097s-.09-.179-.09-.346v-3.116c0-.166.03-.28.09-.346.06-.062.168-.095.323-.095h3.174c.155 0 .261.033.323.095.06.066.09.18.09.346v3.116c0 .167-.03.28-.09.346z"
  }));
});
export default SvgAlertWarning;